export default __webpack_public_path__ + "static/media/logo-light.e22fc510.svg";